import React from 'react';
import { useTranslation } from 'react-i18next';

export function AlignmentConfig({ obj, handleAlignment, dataName }) {
  const { t } = useTranslation('common');
  return (
    <div className="pl-0 pr-2 py-3">
      <p className="mb-2 f-14 text-bold"> {t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.ALIGNMENT_CONFIG.ALIGNMENT')}</p>
      <div className="alignment-container">
        <div className="align-radio-control mr-2">
          <input
            type="radio"
            id={`${dataName}_left`}
            onChange={handleAlignment}
            checked={obj?.otherConfiguration?.[dataName] === 'left'}
            name={dataName}
            value="left"
          />
          <label htmlFor={`${dataName}_left`} title={t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.ALIGNMENT_CONFIG.LEFT')}>
            <span className="icon-align_left_new cursor-pointer" />
          </label>
        </div>
        <div className="align-radio-control mr-2">
          <input
            type="radio"
            id={`${dataName}_center`}
            onChange={handleAlignment}
            checked={obj?.otherConfiguration?.[dataName] === 'center'}
            name={dataName}
            value="center"
          />
          <label htmlFor={`${dataName}_center`} title={t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.ALIGNMENT_CONFIG.CENTER')}>
            <span className="icon-align_center_new cursor-pointer" />
          </label>
        </div>
        <div className="align-radio-control mr-2">
          <input
            type="radio"
            id={`${dataName}_right`}
            onChange={handleAlignment}
            checked={obj?.otherConfiguration?.[dataName] === 'right'}
            name={dataName}
            value="right"
          />
          <label htmlFor={`${dataName}_right`} title={t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.ALIGNMENT_CONFIG.RIGHT')}>
            <span className="icon-align_right_new cursor-pointer" />
          </label>
        </div>
      </div>
    </div>
  );
}

export default AlignmentConfig;
